<template>
  <!-- ######################################## -->
  <!-- row do banner -->
  <!-- ######################################## -->
  <v-row no-gutters id="banner-do-aluno">
    <v-responsive :aspect-ratio="16 / 10">
      <div class="foto-do-banner"></div>
    </v-responsive>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    async makeRequest() {
      const response = await this.axios.get("/");
    }
  }
};
</script>

<style scoped>
.foto-do-banner {
  height: 100%;
  width: 100%;
  background-image: url("../assets_aluno/foto_banner.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
